module.exports = __webpack_public_path__ + "img/hebergement.7ab943ab.jpg";